var opt1 = "Simple";
var opt2 = "Non Fader";
var opt3 = "Normal";
var defaultFrame = '';
var defaultLens = '';
var defaultArm = '';
var selectedArm = '';
var currProductWrap = "";
var curpHandle = "";

// enable image scroll
var productPhotosHeight = $('#product-photos').height();
var productPhotosTop = $('.header').height() + 17;
var windowWidth = $(window).width();
var windowHeight = $(window).height();
var custWidth = $('.custom-product-info').parents('.one-half').width();

// if (window.addEventListener) {
//   window.addEventListener("load", initCustomizer, true);
// }
// else if (window.attachEvent) {
//   window.attachEvent("onload", initCustomizer);
// }
// else {
//   window.onload = initCustomizer;
// }

$(document).ready(function () {
	initCustomizer();
});
  
function initCustomizer(){
  $(".load_view_wrapper a").click( function() {
    $(".load_view_wrapper a").removeClass("active");
    $(this).addClass("active");
    if($(this).hasClass("load_frontView")) {
      $(".preview").addClass("loadFront").removeClass("loadSide");       
    }
    else{
      $(".preview").addClass("loadSide").removeClass("loadFront");       
    }
    return false;
  });
  
	 if($(window).width() > 768) {
		 var footerTop = $('.product-form-wrap').height();
			 
		 $(window).bind('scroll', function() {
          
				var mTop = $(window).scrollTop() - productPhotosTop + $('.main-nav').height();
             	
				//if ($(window).scrollTop() > productPhotosTop) {
                  if($(window).scrollTop() > ($('.main-nav').height() + $('.custom-product-info').height()) ) {
           
					if(mTop < (footerTop-$('#product-photos .preview').height()) && window.innerWidth > 768) {
							$('#scrollPreview').css('margin-top', mTop); 
                            $('#scrollPreview-sticky').css('margin-top', mTop); 
					} else {
							//$('#scrollPreview').css('margin-top', footerTop);
					}

					if(mTop < (footerTop-$('.custom-product-info').height())) {
						$('.type-picker').css('marginTop', 354);
						$('.custom-product-info').addClass("sticky").width(custWidth);
					}else{
						$('.type-picker').css('marginTop', 254);
						$('.custom-product-info').removeClass("sticky").width(custWidth);
					}
				//}
                }
				else {
					//$('.type-picker').css('marginTop', 254);
					$('.type-picker').css('marginTop', 20);
					$('.custom-product-info').removeClass("sticky");
					$('#scrollPreview').css('margin-top', '0px');
                    $('#scrollPreview-sticky').css('margin-top', '0px');
				}
			});
     }else{
       /*
         var footerTop = $('.product-form-wrap').height();		 
		 $(window).bind('scroll', function() {
				var mTop = $(window).scrollTop() - productPhotosTop + $('.main_nav').height();
				if ($(window).scrollTop() > productPhotosTop) {
					if(mTop < (footerTop-$('#product-photos .preview').height()) && window.innerWidth > 68) {
							//$('#scrollPreview').css('margin-top', mTop); 
					} else {
							//$('#scrollPreview').css('margin-top', footerTop);
					}

					if(mTop < (footerTop-$('.custom-product-info').height())) {
						$('.type-picker').css('marginTop', 354);
						$('.custom-product-info').addClass("sticky").width(custWidth);
					}else{
						$('.type-picker').css('marginTop', 254);
						$('.custom-product-info').removeClass("sticky").width(custWidth);
					}
				}
				else {
					$('.type-picker').css('marginTop', 254);
					$('.custom-product-info').removeClass("sticky");
					$('#scrollPreview').css('margin-top', '0px');

             
				}
			});*/
       
     }
  
  }

  //$(".product-variants").hide();
  currProductWrap = "#" + $(".product-form-wrap > div:first").attr("id");
  curpHandle = currProductWrap.replace("#tab-","");

  defaultFrame = $(currProductWrap).find('.frame-picker li').first().find('a');
  defaultLens = $(currProductWrap).find('.lens-picker li').first().find('a');
  defaultArm = $(currProductWrap).find('.arm-picker li').first().find('a');

  $('#glass-frame').append('<img src="'+ p_imgs[curpHandle][$(defaultFrame).attr('rel')] +'" alt="glass-frame" />');
  $('#glass-lens').append('<img src="'+ p_imgs[curpHandle][$(defaultLens).attr('rel')] +'" alt="glass-lens" />');
  $('#glass-arm').append('<img src="'+ p_imgs[curpHandle][$(defaultArm).attr('rel')] +'" alt="glass-arm" />');

  //$('#glass-frame-sticky').append('<img src="'+ p_imgs[curpHandle][$(defaultFrame).attr('rel')] +'" alt="glass-frame" />');
 // $('#glass-lens-sticky').append('<img src="'+ p_imgs[curpHandle][$(defaultLens).attr('rel')] +'" alt="glass-lens" />');
  //$('#glass-arm-sticky').append('<img src="'+ p_imgs[curpHandle][$(defaultArm).attr('rel')] +'" alt="glass-arm" />');

  $('.glass-frame-sticky').append('<img src="'+ p_imgs[curpHandle][$(defaultFrame).attr('rel')] +'" alt="glass-frame" />');
  $('.glass-lens-sticky').append('<img src="'+ p_imgs[curpHandle][$(defaultLens).attr('rel')] +'" alt="glass-lens" />');
  $('.glass-arm-sticky').append('<img src="'+ p_imgs[curpHandle][$(defaultArm).attr('rel')] +'" alt="glass-arm" />');

  
  onImgLoad();
  
  // on FRAME TYPE change
  $(".type-picker .options a").click(function() {
    //var dataName = $(this).parents('.type-picker').attr('data-name');
    curpHandle = $(this).parent('li').data('type');
    currProductWrap = $('#tab-'+curpHandle);
    $('.type-picker li').removeClass('active');
    $('.type-picker li[data-type="'+$(this).parent("li").attr("data-type")+'"]').addClass("active");

    var DefaultProduct = $(this).parent('li').data('title');
    $(".product_name").text(DefaultProduct);
    $(".selected-type").text(DefaultProduct);

    $('.tab-cnt').removeClass('current');
    $(currProductWrap).addClass('current');

    defaultFrame = $(currProductWrap).find('.frame-picker li').first().find('a');
    defaultLens = $(currProductWrap).find('.lens-picker li').first().find('a');
    defaultArm = $(currProductWrap).find('.arm-picker li').first().find('a');

    $(currProductWrap).find('.frame-picker li').removeClass('active');
    $(defaultFrame).parent('li').first().addClass('active');
    $(currProductWrap).find('.lens-picker li').removeClass('active');
    $(defaultLens).parent('li').first().addClass('active');
    $(currProductWrap).find('.arm-picker li').removeClass('active');
    $(defaultArm).parent('li').first().addClass('active');

    $("#glass-frame img").attr("src", p_imgs[curpHandle][$(defaultFrame).attr('rel')]);
    $("#glass-lens img").attr("src", p_imgs[curpHandle][$(defaultLens).attr('rel')]);
    $("#glass-arm img").attr("src", p_imgs[curpHandle][$(defaultArm).attr('rel')]);

   // $("#glass-frame-sticky img").attr("src", p_imgs[curpHandle][$(defaultFrame).attr('rel')]);
   // $("#glass-lens-sticky img").attr("src", p_imgs[curpHandle][$(defaultLens).attr('rel')]);
   // $("#glass-arm-sticky img").attr("src", p_imgs[curpHandle][$(defaultArm).attr('rel')]);

    $(".glass-frame-sticky img").attr("src", p_imgs[curpHandle][$(defaultFrame).attr('rel')]);
    $(".glass-lens-sticky img").attr("src", p_imgs[curpHandle][$(defaultLens).attr('rel')]);
    $(".glass-arm-sticky img").attr("src", p_imgs[curpHandle][$(defaultArm).attr('rel')]);

    
    
    onImgLoad();

    $(defaultFrame).click();
    // var selectedFrame = $(defaultFrame).attr('rev');
    // $(currProductWrap).find(".selected-frame").text(selectedFrame);
    // $(currProductWrap).find('.customizer_frame').val(selectedFrame);

    $(defaultLens).click();
    // var selectedLens = $(defaultLens).attr('rev');
    // $(currProductWrap).find(".selected-lens").text(selectedLens);
    // $(currProductWrap).find('.customizer_lens').val(selectedLens);

    $(defaultArm).click();
    var selectedArm = $(defaultArm).attr('rev');
    // $(currProductWrap).find(".selected-arm").text(selectedArm);
    // $(currProductWrap).find('.customizer_arm').val(selectedArm);
    changeSelectopt();
    return false;
  });
  
//  on FRAME COLOR, LENS COLOR, ARM change
$(".option-picker .options a").click(function() {
  var dataName = $(this).parents('.picker').attr('data-name');

  $(this).parents('.options').find('li').removeClass('active');
  $(this).parent('li').addClass('active');      
  //alert(p_imgs[curpHandle][$(this).attr('rel')]);
      
  $("#glass-"+dataName+" img").attr("src",p_imgs[curpHandle][$(this).attr('rel')]);
 //  $("#glass-"+dataName+"-sticky img").attr("src",p_imgs[curpHandle][$(this).attr('rel')]); // RQ added
  $(".glass-"+dataName+"-sticky img").attr("src",p_imgs[curpHandle][$(this).attr('rel')]); // RQ added
  $(currProductWrap).find(".selected-"+dataName).text($(this).attr('rev'));
  $(currProductWrap).find('.customizer_'+dataName).val($(this).attr('rev'));

  changeSelectopt(this, dataName);
  onImgLoad();
  
  	 if($(window).width() < 900) {
  		//$("html, body").animate({ scrollTop: 0 }, "slow"); //RQ! stop scroll on mobile
        $(".rq-click-to-large").animate({ scrollTop: 0 }, "slow");
       
     }
  return false;
});

 
$(".rq-click-to-large").click(function() {
   //if($(window).width() < 900) {
  	  $("html, body").animate({ scrollTop: 0 }, "slow");
   //}
  return false;
});

/*function getOptiorel(){
  var newRel = opt1 + '-' + opt2 + '-' + opt3;
  return newRel;
}
*/
function changeSelectopt(selected, dataName) {
  if(dataName && selected) {
    if(dataName === 'lens') {
      if ($(selected).attr('rel').toLowerCase().indexOf("polarized") > -1) { opt1 = 'Polarized'; }
      else { opt1 = 'Simple'; }
      $(currProductWrap).find('.single-option-selector[data-option="option1"]').val(opt1).trigger('change');
    }
    else if(dataName === 'frame') {
      if ($(selected).attr('rel').toLowerCase().indexOf("fader") > -1) { opt2 = 'Fader'; }
      else { opt2 = 'Non Fader'; }
      $(currProductWrap).find('.single-option-selector[data-option="option2"]').val(opt2).trigger('change');      
    }
    else if(dataName === 'arm') {
      selectedArm = $(selected).attr('rev');
      if ($(selected).attr('rel').toLowerCase().indexOf("upgrade") > -1) { opt3 = 'Upgrade'; }
      else { opt3 = 'Normal'; }
      $(currProductWrap).find('.single-option-selector[data-option="option3"]').val(opt3).trigger('change');
    }
  }
  else {
    if ($(defaultFrame).attr('rel').toLowerCase().indexOf("polarized") > -1) { opt1 = 'Polarized'; }
    else { opt1 = 'Simple'; }

    if ($(defaultLens).attr('rel').toLowerCase().indexOf("fader") > -1) { opt2 = 'Fader'; }
    else { opt2 = 'Non Fader'; }

    if(selectedArm !== '') {
      $(currProductWrap).find('.arm-picker li').removeClass('active');
      $(currProductWrap).find("a[rev='"+selectedArm+"']").parent('li').addClass('active');
      $(currProductWrap).find(".selected-arm").text(selectedArm);
      $(currProductWrap).find('.customizer_arm').val(selectedArm);
    }
    $(currProductWrap).find('.single-option-selector[data-option="option1"]').val(opt1).trigger('change');
    $(currProductWrap).find('.single-option-selector[data-option="option2"]').val(opt2).trigger('change');
    //$(currProductWrap).find('.single-option-selector[data-option="option3"]').val(opt3).trigger('change');
  }
  //alert(opt1+'-'+opt2+'-'+opt3);  
  //optString = getOptiorel();
  //alert(optString);
  return false;
}

function onImgLoad() {
  $('.overlay').show();
  var cnt = 0;

  $('.preview img').each(function(e, i) {
    if(this.complete) {
      cnt++;
      if(cnt>=4) {
        $('.overlay').hide();
        cnt = 0;
      }
    } else {
			if ($(this).attr('src')) {
				$(this).load($(this).attr('src'), function() {
					cnt++;
					if(cnt>=4) {
						$('.overlay').hide();
						cnt = 0;
					}
				});
			}
    }
  });
}
